"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggle = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const plds_tokens_1 = require("@paclife/plds.tokens");
const Wrapper = styled_components_1.default.div `
  display: flex;

  & label {
    height: 24px;
  }
`;
const ToggleInput = styled_components_1.default.input `
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: inline-block;
  width: 44px;
  height: 24px;
  box-sizing: border-box;
  border-radius: 16px;
  outline: none;
  background-color: ${plds_tokens_1.Colors.neutral500};
  cursor: pointer;
  position: relative;
  z-index: ${plds_tokens_1.ZIndices.high};
  box-shadow: none;
  margin: 0;
  padding: 0;

  /* Custom Circle */
  &::before {
    content: "";
    position: absolute;
    top: 4px;
    left: 4px;
    display: block;
    border-radius: ${plds_tokens_1.Radii.circle};
    width: 16px;
    height: 16px;
    background: #fff;
    transition: transform ${plds_tokens_1.Durations.medium}s;
  }

  &:hover {
    background-color: ${plds_tokens_1.Colors.neutral600};
    box-shadow: none;
    border-color: ${plds_tokens_1.Colors.neutral600};

    &::before {
      transform: translateX(3px);
    }
  }

  &:focus-visible {
    /* Focus Shadow */
    &::after {
      content: "";
      position: absolute;
      width: 48px;
      height: 28px;
      box-sizing: border-box;
      border-radius: 16px;
      top: -2px;
      left: -2px;
      box-shadow: 0 0 1px 2px rgba(13, 101, 179, 0.5);
    }
  }

  &:checked {
    box-shadow: none;
    background: ${plds_tokens_1.Colors.primary};
    border-color: ${plds_tokens_1.Colors.primary};

    &:hover {
      background-color: ${plds_tokens_1.Colors.blue700};
      border-color: ${plds_tokens_1.Colors.blue700};
    }

    &::before {
      transform: translateX(19px);
      transition: transform ${plds_tokens_1.Durations.medium}s;
    }
  }

  /* On dark */
  ${({ dark }) => dark &&
    (0, styled_components_1.css) `
      background-color: ${plds_tokens_1.Colors.neutral300};
      border-color: ${plds_tokens_1.Colors.neutral300};

      &::before {
        background: ${plds_tokens_1.Colors.blue900};
      }

      &:hover {
        background-color: ${plds_tokens_1.Colors.neutral200};
        border-color: ${plds_tokens_1.Colors.neutral200};
      }

      &:focus-visible {
        /* Focus Shadow */
        &::after {
          content: "";
          position: absolute;
          width: 48px;
          height: 28px;
          box-sizing: border-box;
          border-radius: 16px;
          top: -2px;
          left: -2px;
          box-shadow: 0 0 1px 2px rgba(83, 165, 237, 0.9);
        }
      }

      &:checked {
        background: ${plds_tokens_1.Colors.blue300};
        border-color: ${plds_tokens_1.Colors.blue300};

        &:hover {
          background: ${plds_tokens_1.Colors.blue200};
          border-color: ${plds_tokens_1.Colors.blue200};
        }
      }
    `}

  &:disabled {
    background-color: ${plds_tokens_1.Colors.neutral300};
    cursor: default;
    &::after {
      content: "OFF";
      position: absolute;
      font-size: 10.24px;
      font-weight: 700;
      line-height: 16px;
      color: ${plds_tokens_1.Colors.neutral0};
      top: 4px;
      left: auto;
      right: 3px;
    }

    &:checked {
      &:hover {
        background-color: ${plds_tokens_1.Colors.neutral300};
      }
      &::after {
        content: "ON";
        position: absolute;
        font-size: 10.24px;
        font-weight: 700;
        line-height: 16px;
        color: ${plds_tokens_1.Colors.neutral0};
        top: 4px;
        left: 5px;
      }
    }
  }
`;
const Text = styled_components_1.default.span `
  color: ${plds_tokens_1.Colors.neutral1000};
  margin-left: ${plds_tokens_1.Spacing[8]};
  font-family: ${plds_tokens_1.FontFamilies.openSans};
  font-weight: ${plds_tokens_1.FontWeights[400]};
  font-style: normal;
  font-size: ${plds_tokens_1.FontSizes.productBody};
  line-height: ${plds_tokens_1.LineHeights[200]};

  ${({ dark }) => dark &&
    (0, styled_components_1.css) `
      color: ${plds_tokens_1.Colors.textBodyDark};
    `}
`;
const Toggle = (_a) => {
    var { className, id, label, dark = false } = _a, ToggleInputProps = __rest(_a, ["className", "id", "label", "dark"]);
    return (react_1.default.createElement(Wrapper, { className: className },
        react_1.default.createElement("label", { htmlFor: id },
            react_1.default.createElement(ToggleInput, Object.assign({ type: "checkbox", id: id, dark: dark }, ToggleInputProps))),
        label && react_1.default.createElement(Text, { dark: dark }, label)));
};
exports.Toggle = Toggle;
//# sourceMappingURL=toggle.js.map